import { SVGProps } from 'react';

export default function Engineering(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="6.95996"
        y="3.70074"
        width="4.62768"
        height="2.8923"
        fill="currentColor"
        fillOpacity="0.4"
      />
      <rect
        x="6.95996"
        y="9.48566"
        width="4.62768"
        height="2.8923"
        fill="currentColor"
        fillOpacity="0.4"
      />
      <rect
        x="6.95996"
        y="15.2706"
        width="4.62768"
        height="2.8923"
        fill="currentColor"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6859 9.48613V12.3788H11.5874V15.2711H19.6859V18.1628H11.5874V21.0551H21.9997L21.9997 21.0548V3.70109H21.9999V0.808792H21.9997V0.808716H19.6859V0.808792H11.5876V3.70109H19.6859V6.59383H11.5874V9.48613H19.6859Z"
        fill="currentColor"
      />
      <circle cx="2.62137" cy="5.14709" r="1.73538" fill="currentColor" />
      <circle
        opacity="0.7"
        cx="2.62137"
        cy="11.221"
        r="1.73538"
        fill="currentColor"
      />
      <circle
        opacity="0.3"
        cx="2.62137"
        cy="17.295"
        r="1.73538"
        fill="currentColor"
      />
    </svg>
  );
}
